import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {withRouter} from "react-router-dom";
import axios from '../../../_services/api/axios';
import withErrorHandler from '../../../_hoc/withErrorHandler';
import Aux from '../../../_hoc/_Aux';
import styles from "../../molecules/ScrollTable/ScrollTable.scss"
import * as actionCreators from '../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';
import ReactTooltip from 'react-tooltip'

import { secondsFormatter, dateFormatter, toIsoDate } from '../../../_helpers/DateTime.js';

import { PageTemplate, Header, Box, BoxTitle, Spacer, GreyBox, PageTitle, Flex, FlexColumn, Input, InputRow, Text, Button, Icon, DatePicker } from 'components'

class JobsPage extends Component {
	state = {
        search: {
        	searchText: "",
        	start_date: "",
        	start_date_iso: "",
        	start_date_moment_obj: null,
			end_date: "",
        	end_date_iso: "",
			end_date_moment_obj: null
		},
        gradiantOverlay: false
    }

	componentDidMount() {
		this.props.onFetchJobs();
	}

	componentDidUpdate = (prevProps, prevState, snapshot) => {
		if(!this.props.state.loading && prevProps.state.loading) {
			ReactTooltip.rebuild();
		}
	}

    inputChangedHandler = (event, inputIdentifier) => {
        let value = event.target.value;
    	this.setState(prevState => ({
            search: {
                ...prevState.search,
                [inputIdentifier]: value
            }
        }));
    }
	
	inputDateChangedHandler = (start_date, end_date) => {
		if (start_date) {
			let start_date_to_date = start_date.toDate();
		  this.setState((prevState) => ({
			search: {
			  ...prevState.search,
			  ["start_date"]: dateFormatter(start_date_to_date),
			  ["start_date" + "_iso"]: toIsoDate(start_date_to_date),
			  ["start_date"+"_moment_obj"]: start_date
			},
		  }));
		} else {
		  this.setState((prevState) => ({
			search: {
			  ...prevState.search,
			  ["start_date"]: "",
			  ["start_date" + "_iso"]: "",
			  ["start_date"+"_moment_obj"]: null
			},
		  }));
		}
	
		if (end_date) {
		 let  end_date_to_date = end_date.toDate();
		  this.setState((prevState) => ({
			search: {
			  ...prevState.search,
			  ["end_date"]: dateFormatter(end_date_to_date),
			  ["end_date" + "_iso"]: toIsoDate(end_date_to_date),
			  ["end_date"+"_moment_obj"]: end_date
			},
		  }));
		} else {
		  this.setState((prevState) => ({
			search: {
			  ...prevState.search,
			  ["end_date"]: "",
			  ["end_date" + "_iso"]: "",
			  ["end_date"+"_moment_obj"]:null
			},
		  }));
		}
	
	  };

    inputSubmitHandler = (event, inputIdentifier) => {
    	if(event.keyCode === 13 || !inputIdentifier) {
    		let searchData = {}
    		if(this.state.search.searchText.length) {
    			searchData.searchText = this.state.search.searchText;
    		}
    		if(this.state.search.start_date_iso.length) {
    			searchData.start_date = this.state.search.start_date_iso;
    		}
    		if(this.state.search.end_date_iso.length) {
    			searchData.end_date = this.state.search.end_date_iso;
    		}
    		this.props.onFetchJobs(searchData);
    	}
    }



	wheel(e) {
		if(e.deltaX === 0){
		    if (e.deltaY >= 0) {
		    	document.getElementById('scroll').scrollLeft += 40;
		    }
		    else {
		    	document.getElementById('scroll').scrollLeft -= 40;
		    }



		    let tmpState = false
		    if(document.getElementById('scroll').scrollLeft == 0){
		    	tmpState = false;
		    }else{
		    	tmpState = true;
		    }

			this.setState(prevState => ({
	            gradiantOverlay: tmpState
	        }));

		    e.preventDefault();
		}
	}

	round(number, length) {

	  let factor = Math.pow(10, length);
	  let rounded = Math.round(number * factor) / factor

	  return rounded
	}

	openJob = (url) => {
		this.props.history.push(url);
	}

	render() {
		let jobs = null;
		let average = {
			pieces: 0,
			heads: 0,
			total_production_cost: 0,
			total_production_time: 0,
			optimal_total_production_cost: 0,
			optimal_total_production_time: 0,
			optimal_heads: 0,
			potential_total_production_cost: 0,
			potential_total_production_time: 0
		}
		let total = {
			pieces: 0,
			heads: 0,
			total_production_cost: 0,
			total_production_time: 0,
			optimal_total_production_cost: 0,
			optimal_total_production_time: 0,
			optimal_heads: 0,
			potential_total_production_cost: 0,
			potential_total_production_time: 0
		}

		if(this.props.state.jobs.length) {
			this.props.state.jobs.map((job, index) => {
				Object.keys(average).map((key, index) => {
					if(key !== 'pieces') {
				   		average[key] = average[key] + job.calculation[key];
				   		total[key] = total[key] + job.calculation[key];
				   	}
				   	else {
				   		average[key] = average[key] + (job[key] * job['orders']);
				   		total[key] = total[key] + (job[key] * job['orders']);
				   	}
				});
			});
			Object.keys(average).map((key, index) => {
			   average[key] = average[key]/this.props.state.jobs.length;
			});
			jobs = (
				<div className={styles.shadow}>
					<div className={styles.parent} id="scroll" onWheel = {(e) => this.wheel(e)}>
				      <div className={styles.wrapper}>
		                <div className={styles.jobList}>

		                	<div className={styles.jobListRow}>
								<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.titleColumn + ' ' + (this.state.gradiantOverlay ? styles.shadow : ' ')}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.reference')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
								<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.date')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
								<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.pieces')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.potential_cost')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.potential_time')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.optimal_heads')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.actual_cost')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.actual_time')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.optimal_cost')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.optimal_time')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.recalculated')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.machine')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.modular')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
									<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.actual_heads')} data-event='click' data-for='GlobalTooltip' data-place="top">
									<Icon type="image" content="hint" size="13px" display="inline" />
									</div>
								</div>
		                	</div>
							<div className={styles.jobListRow + ' ' + styles.spacer}>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
							</div>

		                	<div className={styles.jobListRow}>
								<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.titleColumn + ' ' + (this.state.gradiantOverlay ? styles.shadow : ' ')}>
									{this.props.translate('global.job.table.header_reference')}
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight + ' ' + styles.firstCellMover}>
									{this.props.translate('global.job.table.header_date')}
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									{this.props.translate('global.job.table.header_pieces')}
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									<Icon type="image" content="cost" size="13px" display="inline" />
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_potential')}</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									<Icon type="image" content="time" size="13px" display="inline" />
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_potential')}</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
		                			{this.props.translate('global.job.table.header_heads')}
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_optimal')}</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									<Icon type="image" content="cost" size="13px" display="inline" />
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_actual')}</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									<Icon type="image" content="time" size="13px" display="inline" />
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_actual')}</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									<Icon type="image" content="cost" size="13px" display="inline" />
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_optimal')}</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									<Icon type="image" content="time" size="13px" display="inline" />
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_optimal')}</div>
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
									{this.props.translate('global.job.table.header_recalculated')}
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.jobMachineName}>
									{this.props.translate('global.job.table.header_machine')}
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.cellIcon}>
									{this.props.translate('global.job.table.header_modular')}
								</div>
		                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight + ' ' + styles.lastColumn}>
									{this.props.translate('global.job.table.header_heads')}
									<div className={styles.subLine}>{this.props.translate('global.job.table.header_actual')}</div>
								</div>
		                	</div>


							{this.props.state.jobs.map((job, index) =>
							<div key={index} className={styles.jobListRow} onClick={this.openJob.bind(this, '/jobs/'+job.Id)}>
								<div className={styles.jobListCell + ' ' + styles.titleColumn + ' ' + (this.state.gradiantOverlay ? styles.shadow : ' ')}>
									<div className={styles.textWrap}>{job.name}</div>
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight + ' ' + styles.firstCellMover}>
									{dateFormatter(job.created_on)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{job.orders * job.pieces}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(job.calculation.potential_total_production_cost, 2) != 0 ? this.round(job.calculation.potential_total_production_cost, 2) : '-'}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{secondsFormatter(job.calculation.potential_total_production_time)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{job.calculation.optimal_heads}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(job.calculation.total_production_cost, 2)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{secondsFormatter(job.calculation.total_production_time)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(job.calculation.optimal_total_production_cost, 2)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{secondsFormatter(job.calculation.optimal_total_production_time)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{job.global_settings ? (<Icon type="image" content="yes" size="10px" display="inline" />) : (<Icon type="image" content="no" size="10px"  display="inline" />)}
								</div>
								<div className={styles.jobListCell}>
									<div className={styles.textWrap}>
										{job.calculation.name}
									</div>
								</div>
								<div className={styles.jobListCell + ' ' + styles.cellIcon}>
									{!job.calculation.multihead ? (<Icon type="image" content="yes" size="10px" display="inline" />) : (<Icon type="image" content="no" size="10px"  display="inline" />)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight + ' ' + styles.lastColumn}>
									{job.calculation.heads}
								</div>
		                	</div>
							)}
							<div className={styles.jobListRow + ' ' + styles.spacer}>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell}></div>
							</div>
							<div className={styles.jobListRow + ' ' + styles.average}>
								<div className={styles.jobListCell + ' ' + styles.titleColumn + ' ' + styles.hasHelpIcon + ' ' + (this.state.gradiantOverlay ? styles.shadow : ' ')}>
									<div className={styles.helpIcon}>
										<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.joblisttable.average')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
										</div>
									</div>
									<div className={styles.textWrap}>
										<div style={{marginTop: 1, paddingRight: 3, float: 'left'}}>
											<Icon type="image" content="average" size="13px" display="inline" />
										</div>
										{this.props.state.jobs.length > 1 ? this.props.translate('global.job.table.average_title.multiple',{jobs:this.props.state.jobs.length}) : this.props.translate('global.job.table.average_title.one',{jobs:this.props.state.jobs.length}) }
									</div>
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight + ' ' + styles.firstCellMover}></div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(average.pieces,2)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(average.potential_total_production_cost, 2) != 0 ? this.round(average.potential_total_production_cost, 2) : '-'}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{secondsFormatter(average.potential_total_production_time)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(average.optimal_heads,2)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(average.total_production_cost, 2)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{secondsFormatter(average.total_production_time)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{this.round(average.optimal_total_production_cost, 2)}
								</div>
								<div className={styles.jobListCell + ' ' + styles.isRight}>
									{secondsFormatter(average.optimal_total_production_time)}
								</div>
								<div className={styles.jobListCell}></div>
								<div className={styles.jobListCell + ' ' + styles.cellIcon}></div>
								<div className={styles.jobListCell + ' ' + styles.isRight}></div>
								<div className={styles.jobListCell + ' ' + styles.isRight + ' ' + styles.lastColumn}>
									{this.round(average.heads,2)}
								</div>
							</div>
						</div>
	              	 </div>
	              </div>
	             </div>
			)
		}
		else if (this.props.state.searched) {
			jobs = (
				<Box align="center">
					<Spacer height="15px" />
					<Text color="#AAAAAA">
		                <p>{this.props.translate('jobspage.search.no_results')}</p>
		            </Text> 
		        </Box>
			)

		}
		else {
			jobs = (
				<Box align="center">
					<Spacer height="15px" />
					<Text color="#AAAAAA">
		                <p>{this.props.translate('jobspage.no_jobs')}</p>
		            </Text> 
		            <Button value={this.props.translate('jobspage.first_job')} href="/jobs/new" width="auto"/>
		        </Box>
			)
		}
		if(this.props.state.jobs.length) {
		  	return (
			    <PageTemplate header={<Header />}>
			      <PageTitle>{this.props.translate('jobspage.title')}</PageTitle>
			      <Flex break="l">
			      	<FlexColumn col="24*13" growSM>
				      <GreyBox type="fullWidth">
				      	<BoxTitle>
				      		{this.props.translate('jobspage.search.title')}<br /><br />
				      	</BoxTitle>
			        	<InputRow label={this.props.translate('jobspage.search.label.search')} icon="search">
				      		<Input  identifier="searchText"
				                    type="text"
				                    value={this.state.search.searchText}
				                    changed={this.inputChangedHandler}
				                    keyupped={this.inputSubmitHandler} />
				        </InputRow>
				      	<Flex break="l">
						  	<FlexColumn col="24*9*2">
					        	<DatePicker 
							  		startDateLabel={this.props.translate('jobspage.search.label.date_from')}
							  		endDateLabel={this.props.translate('jobspage.search.label.date_to')}
							  		changed={this.inputDateChangedHandler}
									startDate={this.state.search.start_date_moment_obj}
									endDate= {this.state.search.end_date_moment_obj}
								/>
							</FlexColumn> 
				      		<FlexColumn col="24*6">
				      			<Button value={this.props.translate('jobspage.search.label.submit')} onClick={this.inputSubmitHandler} type="button" nomargin="true"/>
						    </FlexColumn>
				      	</Flex>
				      </GreyBox>
				     </FlexColumn>
				     <FlexColumn col="24*11">
					  <GreyBox type="fullWidth" bgColor="#fbfbfb" borderColor="#F2F2F2">
				      	<BoxTitle>
				      		{this.props.translate('jobspage.comparsion.title')}<br /><br />
				      	</BoxTitle>
				      	<div className={styles.comparisonTable}>
				      		<div className={styles.comparisonTableRow}>
				      			<div className={styles.comparisonTableColumn}>
				      			
				      			</div>
				      			<div className={styles.comparisonTableColumn}>
				      				{this.props.translate('jobspage.comparsion.total')}<span><Icon type="image" content="cost" size="13px" display="inline" /></span>
				      			</div>
				      			<div className={styles.comparisonTableColumn}>
				      				{this.props.translate('jobspage.comparsion.total')}<span><Icon type="image" content="time" size="13px" display="inline" /></span>
				      			</div>
				      		</div>
				      		<div className={styles.comparisonTableRow}>
				      			<div className={styles.comparisonTableColumn}>
				      				{this.props.translate('jobspage.comparsion.actual')}
				      			</div>
				      			<div className={styles.comparisonTableColumn + ' ' + styles.isRight}>
				      				{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(total.total_production_cost, 2)}
				      			</div>
				      			<div className={styles.comparisonTableColumn + ' ' + styles.isRight}>
				      				{secondsFormatter(total.total_production_time)}
				      			</div>
				      		</div>
				      		<div className={styles.comparisonTableRow}>
				      			<div className={styles.comparisonTableColumn}>
				      				{this.props.translate('jobspage.comparsion.optimal')}
				      			</div>
				      			<div className={styles.comparisonTableColumn + ' ' + styles.isRight}>
				      				{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(total.optimal_total_production_cost, 2)}
				      			</div>
				      			<div className={styles.comparisonTableColumn + ' ' + styles.isRight}>
				      				{secondsFormatter(total.optimal_total_production_time)}
				      			</div>
				      		</div>
				      		<div className={styles.comparisonTableRow}>
				      			<div className={styles.comparisonTableColumn + ' ' + styles.isBold}>
				      				{this.props.translate('jobspage.comparsion.potential')}
				      			</div>
				      			<div className={styles.comparisonTableColumn + ' ' + styles.isRight + ' ' + styles.isBold}>
				      				{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(total.potential_total_production_cost, 2)}
				      			</div>
				      			<div className={styles.comparisonTableColumn + ' ' + styles.isRight + ' ' + styles.isBold}>
				      				{secondsFormatter(total.potential_total_production_time)}
				      			</div>
				      		</div>
				      	</div>
				      	<div className={styles.comparisonNote}>
				      		
				      		<span className={styles.content}>
				      			<div className={styles.icon}><Icon type="image" content="hintbulb" size="20px" display="inline" /></div>
				      			{this.props.translate('jobspage.comparsion.best_setup')} <span className={styles.isBold}>{Math.ceil(average.optimal_heads)} {Math.ceil(average.optimal_heads) > 1 ? this.props.translate('jobspage.comparsion.heads') : this.props.translate('jobspage.comparsion.head')}</span>
				      		</span>
				      	</div>
				      </GreyBox>
				     </FlexColumn>
				  </Flex>
			      {jobs}
			    </PageTemplate>
		  	)
		}
		else {
			return (
				<PageTemplate header={<Header />}>
			      <PageTitle>{this.props.translate('jobspage.title')}</PageTitle>
			      <GreyBox type="fullWidth">
			      	<Flex break="m">
			      		<FlexColumn col="24*10">
				        	<InputRow label={this.props.translate('jobspage.search.label.search')} icon="search">
					      		<Input  identifier="searchText"
					                    type="text"
					                    value={this.state.search.searchText}
					                    changed={this.inputChangedHandler}
					                    keyupped={this.inputSubmitHandler} />
					        </InputRow>
					    </FlexColumn>
						<FlexColumn col="24*5*2">
              				<DatePicker 
                    			startDateLabel={this.props.translate('jobspage.search.label.date_from')}
                    			endDateLabel={this.props.translate('jobspage.search.label.date_to')}
                    			changed={this.inputDateChangedHandler}
								startDate={this.state.search.start_date_moment_obj}
								endDate= {this.state.search.end_date_moment_obj}
						   />
              			</FlexColumn>
			      		<FlexColumn col="24*4">
			      			<Button value={this.props.translate('jobspage.search.label.submit')} onClick={this.inputSubmitHandler} type="button" nomargin="true"/>
					    </FlexColumn>
			      	</Flex>
			      </GreyBox>
			      {jobs}
			    </PageTemplate>
			)
		}
	}
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        state: state.calculatorJobs,
        translate: getTranslate(state.locale),
        settingsCompany: state.calculatorSettingsCompany
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchJobs: (searchData) => dispatch(actionCreators.calculatorJobsFetch(searchData)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(JobsPage, axios));


// WEBPACK FOOTER //
// ./src/components/pages/JobsPage/index.js